/**
 * Work sites for employee assignment (aligned with backend AUTO_PUNCH_LOCATIONS).
 */
export const WORK_LOCATION_OPTIONS = [
  {
    key: "sabarmati_riverfront",
    label: "Sabarmati Riverfront Ahmedabad",
    address: "Sabarmati riverfront Ahmedabad",
  },
  {
    key: "torrent_power",
    label: "Torrent Power",
    address: "Torrent Power",
  },
  {
    key: "moon_park",
    label: "Moon Park",
    address: "Moon park",
  },
  {
    key: "yoga_garden",
    label: "Yoga Garden",
    address: "Yoga Garden",
  },
  {
    key: "riverfront_center",
    label: "Sabarmati Riverfront Center",
    address: "Sabarmati Riverfront Center, Ahmedabad",
  },
];

export function getWorkLocationAddress(key) {
  const match = WORK_LOCATION_OPTIONS.find((o) => o.key === key);
  return match?.address || "";
}

export function inferWorkLocationKeyFromAddress(address) {
  const text = String(address || "").toLowerCase();
  if (!text) return "";
  const match = WORK_LOCATION_OPTIONS.find(
    (o) =>
      text.includes(o.label.toLowerCase()) ||
      text.includes(o.address.toLowerCase()) ||
      text.includes(o.key.replace(/_/g, " "))
  );
  return match?.key || "";
}
